export default function WrenchIcon() {
    return (
        <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M31.7202 26.5388C32.2761 25.2631 32.5831 23.8662 32.5831 22.4019V10.2444L20.9162 6.6665L9.2501 10.2444V22.4019C9.17533 31.8353 21.4166 36.8076 28.7041 30.5478"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.6745 14.3564C22.5936 12.3556 19.4697 11.9728 16.9873 13.2047L19.6077 15.7244L18.8098 17.6863L16.7693 18.4535L14.1489 15.9339C12.8677 18.32 13.2667 21.3247 15.3467 23.3255C17.3027 25.2055 20.1797 25.655 22.5796 24.6791L30.8538 32.6359C31.8213 33.5662 33.3898 33.5654 34.3573 32.6359C35.3248 31.7057 35.3248 30.1974 34.3573 29.2671L26.0831 21.3111C27.0972 19.0036 26.6306 16.2372 24.6745 14.3564Z"
                stroke="#F7A40A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
